const declaration = {
  name: null,
  relationDictIndex: null,
  relationDictName: null,
  remarks: null,
};

export default declaration;
